import Swiper from 'swiper';
import domReady from '@wordpress/dom-ready';

domReady(() => {
  const testimonialsCarousels = document.querySelectorAll(
    '.testimonials-carousel-02'
  );

  if (0 < testimonialsCarousels.length) {
    testimonialsCarousels.forEach(function (carousel) {
      const nextElement = carousel.querySelector('.vtx-swiper__next');
      const prevElement = carousel.querySelector('.vtx-swiper__prev');
      const paginationEl = carousel.querySelector('.vtx-swiper__pagination');

      new Swiper(carousel, {
        draggable: true,
        slidesPerView: 'auto',
        autoHeight: true,
        a11y: {
          paginationBulletMessage: 'Aller au témoignage {{index}}',
          nextSlideMessage: 'Prochain témoignage',
          prevSlideMessage: 'Témoignage précédent',
        },
        pagination: {
          el: paginationEl,
          type: 'fraction',
        },
        navigation: {
          nextEl: nextElement,
          prevEl: prevElement,
        },
      });
    });
  }
});
